var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InternalPagesLayout',{attrs:{"refresh":_vm.refresh,"title":"竞猜记录"}},[_c('Record')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }